import { CustomerSettingsKey, GetCustomerSettingsResponse } from "./types";
import { dashboardBFF } from "../axios-instances";
import { getServices } from "src/logs";

const { logger } = getServices();

export const getCustomerSetting = async (
  key: CustomerSettingsKey,
  logsDetailedFeature?: boolean | undefined
) => {
  try {
    const url = `/api/customer-settings/${key}`;

    const response = await dashboardBFF.get(url, {
      headers: {
        "Content-type": "application/json"
      }
    });

    if (response.status === 204) {
      const err = new Error("No content, http status code: 204");
      throw err;
    }

    if (logsDetailedFeature) {
      logger.logTrace({
        message: "getCustomerSetting - response",
        properties: {
          key,
          status: response.status.toString()
        }
      });
    }

    return response.data as GetCustomerSettingsResponse;
  } catch (error) {
    const err = error as Error;
    if (!err.message.includes("204")) {
      logger.logError({
        message: "getCustomerSetting - Exception",
        properties: {
          name: err.name,
          message: err.message,
          stack: err.stack || "unknown stack",
          cause: String(err.cause ?? "unknown cause")
        }
      });
    }
    throw error;
  }
};

